// NX pill and chip (shadcn Badge restyled): tones ok, grey and attn for verdicts and status, outline chip, neutral and brand.
import { cva, type VariantProps } from "class-variance-authority";
import { Slot } from "radix-ui";
import type * as React from "react";

import { cn } from "@/lib/cn";

const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center gap-1.5 overflow-hidden rounded-pill border border-transparent whitespace-nowrap tabular-nums [&>svg]:pointer-events-none [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        ok: "bg-verdict-ok-bg py-0.5 pr-2.5 pl-2 text-xs/5 font-semibold text-verdict-ok-pill [&>svg]:size-3.5",
        grey: "bg-verdict-grey-bg py-0.5 pr-2.5 pl-2 text-xs/5 font-semibold text-verdict-grey-fg [&>svg]:size-3.5",
        attn: "bg-verdict-attn-bg py-0.5 pr-2.5 pl-2 text-xs/5 font-semibold text-verdict-attn-fg [&>svg]:size-3.5",
        neutral: "bg-muted px-2 py-0.5 text-xs/5 font-medium text-ink-2 [&>svg]:size-3.5",
        brand: "bg-selected px-2 py-0.5 text-xs/5 font-semibold text-selected-foreground [&>svg]:size-3.5",
        outline:
          "h-7 border-border bg-card px-2.5 text-chip text-ink-2 [&>svg]:size-3.5 [&>svg]:text-muted-foreground [a&]:hover:border-b3 [button&]:hover:border-b3",
        count: "min-w-5 justify-center bg-muted px-1.5 text-label/[18px] font-semibold text-ink-2",
      },
    },
    defaultVariants: {
      variant: "neutral",
    },
  },
);

type BadgeProps = React.ComponentProps<"span"> & VariantProps<typeof badgeVariants> & { asChild?: boolean };

function Badge({ className, variant = "neutral", asChild = false, ...props }: BadgeProps) {
  const Comp = asChild ? Slot.Root : "span";
  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants, type BadgeProps };
